const overview = {
  title: 'Overview',
  subtitle: "Here's how your business is performing.",
  subtitle_named: "Here's how {{name}} is performing.",
  stats_error: 'Could not load your overview stats. Refresh to try again.',
  revenue: 'Total revenue',
  credit: 'Total credit',
  deposit: 'Total deposit',
  cashflow: 'Total cashflow',
  total_transaction: 'Total transactions',
  redemption_balance: 'Redemption bal.',
  reward_rate: 'Reward rate',
  not_permitted: 'Not permitted',
  performance_overview: 'Performance overview',
  tabs: {
    revenue: 'Revenue',
    loyalty: 'Loyalty',
    review: 'Reviews'
  },
  account_summary: 'Account summary',
  platform_fee: 'Platform fee',
  customer_breakdown: 'Customer breakdown',
  total_customers: 'Total customers',
  new_customers: 'New customers',
  returning_customers: 'Returning customers',
  lost_customers: 'Inactive customers',
  review_ratings: 'Review ratings',
  out_of_five: 'out of 5',
  reviews: 'Reviews'
};

export default overview;